/**
 * Pure logic for building an Akte insert payload from a pool reservation damage report.
 * Extracted for unit-testability — no Supabase calls here.
 */

import { localIsoDate } from './date-utils';

export interface SchadenAkteInput {
  reservierungId: string;
  fahrzeugId: string;
  fahrerMitarbeiterId: string;
  kennzeichen: string;
  fahrzeugMarke: string;
  fahrzeugModell: string;
  beschreibung: string;
  zeitpunkt: string;
  ort?: string | null;
  gegnerKennzeichen?: string | null;
  fotoUrls?: string[] | null;
}

export interface SchadenAktePayload {
  pool_reservierung_id: string;
  fahrzeug_id: string;
  bearbeiter_id: string;
  kennzeichen: string;
  fahrzeug_kennzeichen: string;
  fahrzeug_marke: string;
  fahrzeug_modell: string;
  titel: string;
  beschreibung: string;
  schadendatum: string;
  schadentag: string;
  schadenort: string | null;
  kennzeichen_gegner: string | null;
  schaden_foto_urls: string[] | null;
  business_unit: string;
  status: string;
  prioritaet: string;
  schadenart: string;
}

export function buildSchadenAktePayload(input: SchadenAkteInput): SchadenAktePayload {
  const schadendatum = localIsoDate(new Date(input.zeitpunkt));
  const label = `${input.fahrzeugMarke} ${input.fahrzeugModell}${input.kennzeichen ? ` (${input.kennzeichen})` : ''}`;

  return {
    pool_reservierung_id: input.reservierungId,
    fahrzeug_id: input.fahrzeugId,
    bearbeiter_id: input.fahrerMitarbeiterId,
    kennzeichen: input.kennzeichen,
    fahrzeug_kennzeichen: input.kennzeichen,
    fahrzeug_marke: input.fahrzeugMarke,
    fahrzeug_modell: input.fahrzeugModell,
    titel: `Schadenmeldung: ${label}`,
    beschreibung: input.beschreibung,
    schadendatum,
    schadentag: schadendatum,
    schadenort: input.ort ?? null,
    kennzeichen_gegner: input.gegnerKennzeichen ?? null,
    schaden_foto_urls: input.fotoUrls?.length ? input.fotoUrls : null,
    business_unit: 'gutachter_koop',
    status: 'neu',
    prioritaet: 'mittel',
    schadenart: 'kasko',
  };
}

export function buildSchadenbericht(beschreibung: string, aktenNr: string): string {
  return `${beschreibung} → Akte ${aktenNr}`;
}
